import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import loadjs from 'loadjs';

export default class Cart extends Component {
    componentWillMount() {
        loadjs("/js/main.js")
    }
    
    render() {
        return (
            <React.Fragment>
                <section className="home-slider owl-carousel">
                    <div className="slider-item" style={{"backgroundImage": "url('/images/bg_3.jpg')"}} data-stellar-background-ratio="0.5">
                        <div className="overlay"></div>
                        <div className="container">
                            <div className="row slider-text justify-content-center align-items-center">
                                <div className="col-md-7 col-sm-12 text-center ftco-animate">
                                    <h1 className="mb-3 mt-5 bread">Cart</h1>
                                    <p className="breadcrumbs">
                                        <span className="mr-2">
                                            <Link to="/">Home</Link>
                                        </span>
                                        <span>Cart</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="ftco-section ftco-cart">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 ftco-animate">
                                <div className="cart-list">
                                    <table className="table">
                                        <thead className="thead-primary">
                                            <tr className="text-center">
                                                <th>&nbsp;</th>
                                                <th>&nbsp;</th>
                                                <th>Product</th>
                                                <th>Price</th>
                                                <th>Quantity</th>
                                                <th>Total</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr className="text-center">
                                                <td className="product-remove">
                                                    <a href="#">
                                                        <span className="icon-close"></span>
                                                    </a>
                                                </td>
                                                <td className="image-prod">
                                                    <div className="img" style={{"backgroundImage": "url('/images/menu-2.jpg')"}}></div>
                                                </td>
                                                <td className="product-name">
                                                    <h3>Creamy Latte Coffee</h3>
                                                    <p>Far far away, behind the word mountains, far from the countries</p>
                                                </td>
                                                <td className="price">$4.90</td>
                                                <td className="quantity">
                                                    <div className="input-group mb-3">
                                                        <input type="text" name="quantity" className="quantity form-control input-number" defaultValue="1" min="1" max="100" />
                                                    </div>
                                                </td>
                                                <td className="total">$4.90</td>
                                            </tr>
                                            <tr className="text-center">
                                                <td className="product-remove">
                                                    <a href="#">
                                                        <span className="icon-close"></span>
                                                    </a>
                                                </td>
                                                <td className="image-prod">
                                                    <div className="img" style={{"backgroundImage": "url('/images/dish-2.jpg')"}}></div>
                                                </td>
                                                <td className="product-name">
                                                    <h3>Grilled Ribs Beef</h3>
                                                    <p>Far far away, behind the word mountains, far from the countries</p>
                                                </td>
                                    
                                                <td className="price">$15.70</td>
                                    
                                                <td className="quantity">
                                                    <div className="input-group mb-3">
                                                        <input type="text" name="quantity" className="quantity form-control input-number" defaultValue="1" min="1" max="100" />
                                                    </div>
                                                </td>
                                                <td className="total">$15.70</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-end">
                            <div className="col col-lg-3 col-md-6 mt-5 cart-wrap ftco-animate">
                                <div className="cart-total mb-3">
                                    <h3>Cart Totals</h3>
                                    <p className="d-flex">
                                        <span>Subtotal</span>
                                        <span>$20.60</span>
                                    </p>
                                    <p className="d-flex">
                                        <span>Delivery</span>
                                        <span>$0.00</span>
                                    </p>
                                    <p className="d-flex">
                                        <span>Discount</span>
                                        <span>$3.00</span>
                                    </p>
                                    <hr/>
                                    <p className="d-flex total-price">
                                        <span>Total</span>
                                        <span>$17.60</span>
                                    </p>
                                </div>
                                <p className="text-center">
                                    <Link to="/checkout" className="btn btn-primary py-3 px-4">Proceed to Checkout</Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="ftco-section">
                    <div className="container">
                        <div className="row justify-content-center mb-5 pb-3">
                            <div className="col-md-7 heading-section ftco-animate text-center">
                                <span className="subheading">Discover</span>
                                <h2 className="mb-4">Related products</h2>
                                <p>Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.</p>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="menu-entry">
                                    <a href="#" className="img" style={{"backgroundImage": "url('/images/menu-1.jpg')"}}></a>
                                    <div className="text text-center pt-4">
                                        <h3><a href="#">Coffee Capuccino</a></h3>
                                        <p>A small river named Duden flows by their place and supplies</p>
                                        <p className="price"><span>$5.90</span></p>
                                        <p><a href="#" className="btn btn-primary btn-outline-primary">Add to Cart</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="menu-entry">
                                    <a href="#" className="img" style={{"backgroundImage": "url('/images/menu-2.jpg')"}}></a>
                                    <div className="text text-center pt-4">
                                        <h3><a href="#">Coffee Capuccino</a></h3>
                                        <p>A small river named Duden flows by their place and supplies</p>
                                        <p className="price"><span>$5.90</span></p>
                                        <p><a href="#" className="btn btn-primary btn-outline-primary">Add to Cart</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="menu-entry">
                                    <a href="#" className="img" style={{"backgroundImage": "url('/images/menu-3.jpg')"}}></a>
                                    <div className="text text-center pt-4">
                                        <h3><a href="#">Coffee Capuccino</a></h3>
                                        <p>A small river named Duden flows by their place and supplies</p>
                                        <p className="price"><span>$5.90</span></p>
                                        <p><a href="#" className="btn btn-primary btn-outline-primary">Add to Cart</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-3">
                                <div className="menu-entry">
                                    <a href="#" className="img" style={{"backgroundImage": "url('/images/menu-4.jpg')"}}></a>
                                    <div className="text text-center pt-4">
                                        <h3><a href="#">Coffee Capuccino</a></h3>
                                        <p>A small river named Duden flows by their place and supplies</p>
                                        <p className="price"><span>$5.90</span></p>
                                        <p><a href="#" className="btn btn-primary btn-outline-primary">Add to Cart</a></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        )
    }
}